import script from "./AuditTrailDetailDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditTrailDetailDrawer.vue?vue&type=script&setup=true&lang=js"

import "./AuditTrailDetailDrawer.vue?vue&type=style&index=0&id=61b8ec94&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b8ec94"]])

export default __exports__